export const accountUserToSelectOption = (user) => ({
  label: `${user.display_name} (${user.roles[0].full_name})`,
  value: user.id,
});
